import { createFileRoute } from "@tanstack/react-router";

import { OrgSecurityPage } from "../iam/organization/components/OrgSecurityPage";

/**
 * Route is /organizations/$organizationId/security: the organization's request limits (the
 * monthly allowances and the per-minute rate limits its agreement sets) and its embed safety
 * rules. Open to every role and to staff: an owner or an admin edits the rules that are theirs,
 * staff edit the terms of the agreement, and everybody else reads them.
 */
export const Route = createFileRoute("/_app/organizations/$organizationId/security")({
  component: OrgSecurityPage,
});
